import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col, Button, Table, Form, Spinner } from 'react-bootstrap';
import { resetPagination, MAX_ITEMS_IN_PAGE } from '../../../store/actions/commonActions';
import { fetchPermissions, 
  filterPermissions, 
  fetchRolePermissions,
  RESET_PERMISSIONS_PAGINATION, 
  SET_PERMISSIONS_PAGINATION,
  SUPER_ADMIN
} from '../../../store/actions/permissions/permissionsActions';
import { capitalize } from '../../../common/Utilities'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';

import PageTitle from '../../../common/PageTitle';
import ListPagination from '../../../common/ListPagination';

class Permissions extends Component {

  componentDidMount() {
    this.props.fetchRolePermissions();
    this.props.resetPagination(RESET_PERMISSIONS_PAGINATION);
  }

  filterPermissions = () => {
    return (
      <Form.Control size="xl" type="search" placeholder="Filter Roles & Permissions" onChange={(e) => {
        const filter = e.target.value;
        this.props.filterPermissions(filter);
      }} />
    )
  }

  getFilteredPermissions = (rolePermissions) => {
    if (!rolePermissions) {
      return null;
    }

    return rolePermissions.filter(permission => {
      const role = permission.role_name || '';
      const permissions = permission.permissions.join(' ') || '';

      const permissionData = [
        role,
        permissions
      ].join(" ").toLowerCase();
      
      const permissionFilter = this.props.permissions.permissionFilter; 

      if (!permissionFilter || permissionData.includes(permissionFilter.toLowerCase())) {
        return permission;
      }
      return null;
    })
  }

  renderPermissions = () => {
    
    let rolePermissions = [];

    const rpList = this?.props?.permissions?.rolePermissions || false;
    if (rpList && rpList.length) {
      rpList?.forEach(permission => {
        const pid = permission?.role?.id;
        if (pid === SUPER_ADMIN) return false;
        const index = rolePermissions.findIndex(rp => rp.pid === pid)
        if (index > -1) {
          rolePermissions[index].permissions.push(permission.permission.permission_name)
        } else {
          rolePermissions.push({
            pid: pid,
            role_name: permission.role.role_name,
            permissions: [permission.permission.permission_name],
            updated_at: permission.role.updated_at
          })
        }
      });
    }

    let permissions = this.getFilteredPermissions(rolePermissions);

    if (permissions) {
      //if the user tries to search and no matches the filter
      if (this.props.permissions.permissionFilter && !permissions.length) {
        permissions = null;
      }
      else {
        let min = this.props.permissions.min;
        let max = this.props.permissions.max;
        
        if (!this.props.permissions.permissionFilter) {
          permissions = permissions.slice(min - 1, max);
        }
      }
    } 
   
    let permissionList = [];

    if (permissions) {
      permissionList = permissions.length ? (
        permissions.map((permission, key) => {
          return (
            <tr key={key}>
              <td className="align-center">{capitalize(permission.role_name)}</td>
              <td className="align-center">{permission.permissions
                                              .map(permission => (<>{capitalize(permission)}<br/></>))}</td>
              <td className="align-center">{permission.updated_at}</td>
              <td className="align-right">
                <Button size="sm" className="btn-icon mr-3" onClick={(e) => {
                  e.preventDefault();
                  this.props.history.push('/settings/roles-permissions/edit?id=' + permission.pid)
                }}>
                  <FontAwesomeIcon icon={faPen} /> Edit 
                </Button>
              </td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={4}><Spinner animation="border" size="sm" /></td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={4}><p className="text-danger">No roles found.</p></td>
        </tr>
      )
    }

    return permissionList;
  }

  render() {

    const addRole = <Button id="add-permission" size="sm" onClick={() => {
      this.props.history.push('/settings/roles-permissions/new')
    }}>Add New Role</Button>

    let listPagination = '';

    const permissions = this?.props?.permissions?.rolePermissions || {permissions: [], role: {}};

    if (!permissions.permissionFilter && permissions.max > MAX_ITEMS_IN_PAGE) {
      listPagination = (
        <div className="float-right mt-3">
          <ListPagination 
            dispatchType={SET_PERMISSIONS_PAGINATION}
            data={permissions.clients} 
            min={permissions.min}
            max={permissions.max}
            currentPage={permissions.currentPage} 
            totalPages={permissions.totalPages} 
            fetchCallback="" 
            numItems={permissions.numItems} />
        </div>
      )
    }

    return (
      <Container className="waa-container container">
        <PageTitle pageName="Roles & Permissions" actionButton={addRole} />
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Table
              className="waa-table table"
            >
              <thead>
                <tr>
                  <th className="align-center">ROLE</th>
                  <th className="align-center">PERMISSIONS</th>
                  <th className="align-center">LAST UPDATE</th>
                  <th className="align-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4}>
                    { this.filterPermissions() }
                  </td>
                </tr>
                { this.renderPermissions() }
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row>
          <Col>
            {listPagination}
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToDispatch = (state) => ({
  permissions: state.permissions
})

const mapDispatchToProps = (dispatch) => ({
  fetchPermissions: (...args) => dispatch(fetchPermissions(...args)),
  resetPagination: (...args) => dispatch(resetPagination(...args)),
  filterPermissions: (...args) => dispatch(filterPermissions(...args)),
  fetchRolePermissions: (...args) => dispatch(fetchRolePermissions(...args)),
})

export default withRouter(connect(mapStateToDispatch, mapDispatchToProps)(Permissions))
